import { DISPLAY_DRAWER_THRESHOLD } from '../filmstrip/constants';
export function getClosedCaptionVisibility(state) {
    return state['features/subtitles']._popupVisibility;
}
export function showClosedCaptionDrawer(state) {
    const { clientWidth } = state['features/base/responsive-ui'];
    return clientWidth <= DISPLAY_DRAWER_THRESHOLD;
}
